<template slot="acoes" slot-scope="data">
    <span
        class="text-primary">
        <i
            class="fa fa-pie-chart fa-lg icon-button"
            title="Rateio"
            @click.stop="detalharItemDespesa()"
        ></i>
    </span>
</template>

<script>

export default {
    props: {
        item: {
            type: Object
        },

        rotaDetalharItem: {
            type: String
        }
    },

    methods: {
        detalharItemDespesa() {
            this.$router.push({
                name: this.rotaDetalharItem,
                params: {
                    despesaItemId: this.item.despesaItemId,
                }
            })
        }
    },
}

</script>